import React from "react"
import { FlexContainer, H3, Body } from "@carrotfertility/carotene"
import { CircleImage } from "components/views/atoms/images/CircleImage"
import styled from "styled-components"

const StyledCircleImage = styled(CircleImage)`
  background-color: rgba(210, 101, 86, 0.4);
  margin-right: 16px;
`
type PlanPeriodWarningProps = {
  warningTitle: string
  warningDescription: string
}

const PlanPeriodWarning = ({ warningTitle, warningDescription }: PlanPeriodWarningProps): JSX.Element => {
  return (
    <FlexContainer
      stack="small"
      padding="medium"
      borderRadius="8px"
      sx={{
        backgroundColor: "#FAF0EB"
      }}
    >
      <StyledCircleImage size={38} iconName="icn-mini-app" />
      <div>
        <H3>{warningTitle}</H3>
        <Body size="small">{warningDescription}</Body>
      </div>
    </FlexContainer>
  )
}
export default PlanPeriodWarning
